import { clsx } from 'clsx';
import { CtaComponentClass, useCtaComponentClass } from 'lib/hooks/theming/useCtaComponentClass';
import { CtaSize, CtaStyle, CtaVariant } from './CtaButton';
import styles from './Cta.module.scss';

export function useCtaClass(
  ctaStyle: CtaStyle,
  className: string | undefined,
  ctaComponentClass: CtaComponentClass | undefined,
  ctaVariant: CtaVariant | undefined,
  ctaSize: CtaSize | undefined = 'base'
) {
  const ctaClassVariant = useCtaComponentClass(ctaComponentClass);
  const ctaResolvedVariant = ctaVariant ?? ctaClassVariant;
  return ctaStyle === 'none'
    ? className
    : clsx(styles.cta, className, styles[ctaResolvedVariant], styles[ctaStyle], styles[ctaSize]);
}
